var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownRight(_ref, svgRef) {
  var _ref2, _ref3;

  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.9404 9.01172L20.1354 13.2067L15.9404 17.4016",
    stroke: "#AAAAAA",
    style: (_ref2 = {
      stroke: "#AAAAAA"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.6683 0.6683 0.6683)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35547 3.97656V9.8495C3.35547 10.7396 3.70904 11.5932 4.33841 12.2225C4.96777 12.8519 5.82138 13.2055 6.71144 13.2055H19.2963",
    stroke: "#AAAAAA",
    style: (_ref3 = {
      stroke: "#AAAAAA"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.6683 0.6683 0.6683)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.35684,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRight);
export default __webpack_public_path__ + "static/media/down_right.3597f75c.svg";
export { ForwardRef as ReactComponent };